import { AsyncPipe, LowerCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TimeDisplayService } from '@polaris-customerweb/sharedcomponents.shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { RideCondition } from 'src/app/models/ride-condition';
import { RemoveWhiteSpacePipe } from 'src/app/pipes/remove-whitespace.pipe';
import { RideConditionService } from 'src/app/services/ride-condition.service';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';

@Component({
    imports: [
        AngularSvgIconModule,
        AsyncPipe,
        LowerCasePipe,
        RemoveWhiteSpacePipe,
    ],
    selector: 'rdx-ride-condition-popup',
    standalone: true,
    styleUrls: ['./ride-condition-popup.component.scss'],
    templateUrl: './ride-condition-popup.component.html',
})
export class RideConditionPopupComponent implements OnInit {
    @Input() rideCondition: RideCondition = new RideCondition();
    @Input() shouldShowReportAbuseLink: boolean;

    isAuthenticated$: Observable<boolean>;
    reportedTime: string = '';

    constructor(
        private matSnackBar: MatSnackBar,
        private rideConditionService: RideConditionService,
        private timeDisplayService: TimeDisplayService,
        private userAuthService: UserAuthService
    ) {}

    ngOnInit() {
        this.isAuthenticated$ = this.userAuthService.isAuthenticated$;
        this.reportedTime = this.timeDisplayService.getUpdateTime(
            this.rideCondition.reportedTime
        );
    }

    reportAbuse() {
        this.rideConditionService.reportAbuse(this.rideCondition).subscribe({
            error: () => {
                const failure = $localize`Submit failed`;
                this.matSnackBar.open(failure, '', { duration: 3000 });
            },
            next: () => {
                const success = $localize`Successfully submitted`;
                this.matSnackBar.open(success, '', { duration: 3000 });
            },
        });
    }
}
